import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const storeOptions = {
  state,
  getters,
  actions,
  // Persist the fetched vault products so the dashboard can render last-known
  // vault cards when launched offline (mirrors the dashboard store's persisted
  // cards). Only the display payload is persisted — transient UI flags like
  // vaultLoader/isSyncing are intentionally excluded so they reset each session.
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ['products', 'archivedProducts']
  }
}

export const useVaultStore = defineStore('vault', storeOptions)
